import { getCookie } from 'cookies-next';
import { TYPE_CONSTANT } from '../constant/Web_constant';

export const checkRules = (rules) => {
  if (
    rules === undefined ||
    rules === null ||
    Object.keys(rules).length === 0 ||
    rules?.visibility_rule == ''
  ) {
    return true;
  }

  const isLoggedIN = getCookie(`${TYPE_CONSTANT.DOMAIN}_login`);

  if (
    rules?.is_show_for_all_use_after_login == true ||
    rules?.visibility_rule == 'all_users'
  ) {
    return true;
  } else if (
    (rules?.is_show_if_user_is_logged_in == true ||
      rules?.visibility_rule == 'logged_in') &&
    isLoggedIN
  ) {
    return true;
  } else if (
    (rules?.is_show_if_user_is_not_logged_in == true ||
      rules?.visibility_rule == 'logged_out') &&
    !isLoggedIN
  ) {
    return true;
  } else {
    return false;
  }
};
